import axios from "axios";

export const url = "https://takemyluggage-backend.onrender.com";

export const API = axios.create({
  baseURL: "https://takemyluggage-backend.onrender.com",
});
